module.exports = fox._r("images/slides/slide_1_6.jpg", __webpack_public_path__ + "images/slides/slide_1_6.jpg");


//////////////////
// WEBPACK FOOTER
// ./images/slides/slide_1_6.jpg
// module id = 509
// module chunks = 2